import Vue from "vue";
import Router from "vue-router";

import store from '@/store'

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "login",
    beforeEnter: checkSession,
    // route level code-splitting
    // this generates a separate chunk (login.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: "/account",
    name: "account",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "addresses" */ '../views/Account.vue')
  },
  {
    path: '/addresses',
    name: 'addresses',
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "addresses" */ '../views/Addresses.vue')
  },
  {
    path: '/addresses-add',
    name: 'addresses-add',
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "addresses" */ '../views/AddressesAdd.vue')
  },
  {
    path: "/profile",
    name: "profile",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "profile" */ '../views/Profile.vue')
  },
  {
    path: "/payments-and-subscriptions",
    name: "payments-and-subscriptions",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "payments-and-subscriptions" */ '../views/PaymentsAndSubscriptions.vue')
  },
  {
    path: "/payment-methods",
    name: "payment-methods",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "paymentmethods" */ '../views/PaymentMethods.vue')
  },
  {
    path: "/purchases",
    name: "purchases",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "paymentmethods-add" */ '../views/Purchases.vue')
  },
  {
    path: "/payment-methods-add",
    name: "payment-methods-add",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "paymentmethods-add" */ '../views/PaymentMethodsAdd.vue')
  },
  {
    path: "/password-update",
    name: "password-update",
    beforeEnter: requireAuth,
    component: () => import( /* webpackChunkName: "paymentmethods-add" */ '../views/PasswordUpdate.vue')
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import( /* webpackChunkName: "logout" */ '../views/Logout.vue')
  },
  {
    path: "/signup-finish",
    name: "signup-finish",
    beforeEnter: checkSession,
    component: () => import( /* webpackChunkName: "signup-finish" */ '../views/SignupFinish.vue')
  },
  {
    path: "/signup-start",
    name: "signup-start",
    beforeEnter: checkSession,
    component: () => import( /* webpackChunkName: "signup-start" */ '../views/SignupStart.vue')
  },
  {
    path: "/signup-verify",
    name: "signup-verify",
    beforeEnter: checkSession,
    component: () => import( /* webpackChunkName: "signup-verify" */ '../views/SignupVerify.vue')
  },
  {
    path: "/signup-verify-email",
    name: "signup-verify-email",
    beforeEnter: checkSession,
    component: () => import( /* webpackChunkName: "signup-verify-email" */ '../views/SignupVerifyEmail.vue')
  },
  {
    path: "/account-recovery",
    name: "account-recovery",
    beforeEnter: checkSession,
    component: () => import( /* webpackChunkName: "account-recovery" */ '../views/AccountRecoveryStart.vue')
  },
  {
    path: "/account-recovery-finish",
    name: "account-recovery-finish",
    beforeEnter: checkSession,
    component: () => import( /* webpackChunkName: "account-recovery-finish" */ '../views/AccountRecoveryFinish.vue')
  },
];

function requireAuth(to, from, next) {
  if (store.state.user.isAuthenticated) {
    next()
  } else {
    next({
      name: 'login',
      query: { redirect: to.fullPath },
    })
  }
}

function checkSession(to, from, next) {
  if (store.state.user.isAuthenticated) {
    next({
      name: 'account',
    })
  } else {
    next()
  }
}

export default new Router({
  mode: "history",
  routes
})
